var base = require("navbar/navbar");

Vue.component("spark-navbar", {
    mixins: [base],
    computed: {
        sortedTeams() {
            return this.teams.sort((a, b) =>
                a.name.toLowerCase() < b.name.toLowerCase()
                    ? -1
                    : a.name.toLowerCase() > b.name.toLowerCase()
                    ? 1
                    : 0
            );
        }
    }
});
